import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Modal, Button, ModalBody, ModalFooter, Row, Col} from 'react-bootstrap';
import { loginActions } from '../../../store/user-login.reducer';

class DataPrivacyForm extends Component {
    constructor() {
        super();
    }

    componentDidMount() {
        this.props.newUser();
    }

    logOut = async (event) => {
        this.props.logout();
    };

    render() {
        const {showModal, message } = this.props;
        return (
            <div>
                <Modal className="data-privacy-modal" 
                    show={showModal} 
                    dialogClassName="modal-80w"
                    onHide={e => { this.logOut(e) }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span>Data Privacy</span>
                        </Modal.Title>
                    </Modal.Header>
                    <ModalBody>
                        <div dangerouslySetInnerHTML={{ __html: message }} />  
                        <br/>
                        <Row>
                            <Col>
                                <label className="data-privacy-policy">To continue, please accept the above policy.</label>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Row>
                            <Col>
                                <Button className="data-privacy-button" onClick={this.props.handleAccept}>
                                    Accept policy and continue
                                </Button>
                            </Col>
                        </Row>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        ...bindActionCreators(loginActions, dispatch)
    }
}

function mapStateToProps(state) {
    const { authentication } = state;
        return {
            ...authentication
        };
}
export default connect(mapStateToProps, mapDispatchToProps)(DataPrivacyForm);
